import { render, staticRenderFns } from "./StepInformation.vue?vue&type=template&id=54b37c30&"
import script from "./StepInformation.vue?vue&type=script&lang=js&"
export * from "./StepInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b37c30')) {
      api.createRecord('54b37c30', component.options)
    } else {
      api.reload('54b37c30', component.options)
    }
    module.hot.accept("./StepInformation.vue?vue&type=template&id=54b37c30&", function () {
      api.rerender('54b37c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61980520-8/StepInformation.vue"
export default component.exports